<template>
  <aw-drag
    :enable="bcDocumentStore.edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="bg-white"
  >
    <aw-drop
      :list="children"
      :can-drop-item="canDropItem"
      :create-placeholder="createPlaceholder"
      transition-name="document-elements"
      list-item-key="key"
      @drop-item="drop"
      class="DocumentBlock -heading-2"
      :class="{ DocumentHasPlaceholder: element.placeholder, isCommentOpened: isCommentOpened, DocumentHighlightSearch: $route.hash === '#el' + element.id }"
      :id="'el' + element.id"
    >
      <template #header>
        <div class="DocumentElement -heading-2">
          <div
            class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
            v-if="element.locked && !isEveryElementLocked && !isPageLocked"
          >
            <aw-icon icon="lock" class="w-5 h-5 text-white " />
            <span class="text-white text-sm">{{ $t('Element is locked') }}</span>
          </div>
          <contenteditable
            tag="span"
            v-model="data.header"
            :contenteditable="edit"
            :noNL="true"
            :noHTML="true"
            :alwaysSelectAll="$t('Header')"
            @updated="updated = 'header'"
            :auto-focus="!element.id"
          />
          <!-- <slot></slot> -->

          <!-- comments -->
          <document-comment
            v-if="bcDocumentStore.document.allow_comments"
            v-model="element.comments"
            :element="element"
            :document="bcDocumentStore.document"
            @comment-toggle="resolveZindexOnParent"
          />

          <!-- panel s moznosti noveho elementu -->
          <document-hot-action
            :parent="element"
            :page="page"
            :index="0"
            v-if="edit && !isLastOnPage"
          />
        </div>

        <!-- LEVA -->
        <div class="DocumentBlock__PanelLeft -heading-2"></div>

        <!-- PRAVA -->
        <div class="DocumentBlock__PanelRight -heading-2">
          <span
            ref="DocumentCircle"
            class="DocumentCircle mr-2.5 sm:mr-3.5"
            :class="{
              'DocumentCircle--active':
                bcSelectedStore.selected.has(element.id) &&
                bcSelectedStore.selected.get(element.id)[3],
              'DocumentCircle--child-active':
                bcSelectedStore.selected.has(element.id) &&
                !bcSelectedStore.selected.get(element.id)[3]
            }"
            :data-item-index="element.root_rank"
            @click.prevent.stop="bcSelectedStore.select(
              element, 
              {
                isRecursive: true,
                isShift: $event.shiftKey,
                isDocument: true,
                itemIndex: element.root_rank,
              }
            )"
          >
          </span>
          <span
            class="cursor-move text-gray-400 hover:text-gray-500"
            v-if="edit"
            :ref="dragHandle"
          >
            <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
            <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
          </span>
        </div>
      </template>
    
      <template #default="{ item, index}">
        <!-- List of all elements in after header -->
        <component
          :is="'document-element-' + item.type"
          :element="item"
          :parent="element"
          :page="page"
          :index="index"
          :key="item.key"
          :class="{ DocumentElementDragged: item.dragged }"
          :is-page-locked="isPageLocked"
        />
      </template>
    </aw-drop>
  </aw-drag>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    BaseElement,
    Selected,
  ],
  allowedChildElements: [
    'color',
    'embed',
    'files',
    'gallery',
    //'header',
    'image',
    'locked',
    'preview',
    'table',
    'text'
  ],
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
}
</script>

<style lang="scss" scoped></style>
